import { getAPIPath, request } from './core'

export const reportUsersErrorFeedback = (businessId: string, content: string) =>
  request(
    getAPIPath('email/error'),
    { method: 'POST', data: content, headers: { 'Content-Type': 'text/html' } },
    true,
  )
